<!--<html>
<body>-->
    
    <div class="container-md" style="
    /*display: flex;*/
  justify-content: center;
  align-items: center;
  /*width: 100%;*/
  height: 100vh;">
       
        <div id="surveyContainer">
            <div style="text-align:right">
                <language-choosen #langViewChild (click)="defineLocales()"></language-choosen>
            </div>
            <div id="surveyElement">

            </div>

            <div id="surveyResult"></div>
        </div>
    </div>
<!--</body>
</html>-->
